/**
 * Ryan O'Dowd
 * 2022-03-13
 * © Copyright 2022 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import {
  DELETE,
  FETCH_REQUEST_OBJECT,
  GET,
  JSON_HEADERS,
  PATCH,
  POST,
  PUT,
  SET_OAK_USER,
  SET_WHATS_NEW_NOTES,
  apiDeleteAccount,
  cleanProfilePictureUrls,
  createApiAction,
  fetchChatMessages,
  fetchProfilePictureUrl,
  fetchWhatsNew,
  getFetchTypes,
  getRequestHeaders,
  logout,
  markAllMessagesRead,
  saveFcmToken,
  sendChatMessage,
  sendContactFormMessage,
  setFeedbackChatDraftText,
  setLightDarkMode,
  setMessageReaction,
  setWhatsNewLastReadTimestamp,
  setWhatsNewLastReadVersion,
} from './common';
import {
  addMinutes,
  format as dateFnsFormat,
} from 'date-fns';
import {
  Platform,
} from 'react-native';
/* @TODO:
import {
  RSAA,
} from 'redux-api-middleware';
*/
import Translation from '@utils/db/models/Translation';
import VerseText from '@utils/db/models/VerseText';
import db from '@utils/db';
import globals from '@utils/globals';
import {
  store,
} from '@utils/store';
import {
  v4 as uuidv4,
} from 'uuid';

// action types
export const SET_ACTIVE_GOAL_ID = 'SET_ACTIVE_GOAL_ID';
export const SET_BOOKS = 'SET_BOOKS';
export const SET_MINIGAMES = 'SET_MINIGAMES';
export const SET_BOOK_NAMES = 'SET_BOOK_NAMES';
export const SET_CHAPTERS = 'SET_CHAPTERS';
export const SET_TRANSLATIONS = 'SET_TRANSLATIONS';
export const SET_GOAL = 'SET_GOAL';
export const SET_GOALS = 'SET_GOALS';
export const SET_GOAL_PREVIEW = 'SET_GOAL_PREVIEW';
export const TOGGLE_MINIGAME_ACTIVE = 'TOGGLE_MINIGAME_ACTIVE';
export const SET_VERSES_LAST_UPDATED = 'SET_VERSES_LAST_UPDATED';
export const SET_BOOK_SORT_METHOD = 'SET_BOOK_SORT_METHOD';
export const SET_SHOW_BADGES_IN_READ = 'SET_SHOW_BADGES_IN_READ';
export const SET_PREFERRED_TRANSLATION_ID = 'SET_PREFERRED_TRANSLATION_ID';
export const SET_PREFERRED_VERSE_SELECTION_METHOD = 'SET_PREFERRED_VERSE_SELECTION_METHOD';
export const SET_PREFERRED_SCALE = 'SET_PREFERRED_SCALE';
export const SET_ALL_ASSIGNMENT_PEANUTS = 'SET_ALL_ASSIGNMENT_PEANUTS';
export const SET_SEVEN_DAYS_PEANUTS = 'SET_SEVEN_DAYS_PEANUTS';
export const SET_ASSIGNMENT_PEANUTS = 'SET_ASSIGNMENT_PEANUTS';
export const SET_VERSES_REVIEWED = 'SET_VERSES_REVIEWED';
export const SET_MS_SPENT = 'SET_MS_SPENT';
export const SET_BADGES = 'SET_BADGES';
export const SET_NEW_BADGES = 'SET_NEW_BADGES';
export const CLEAR_ALL_NEW_BADGES = 'CLEAR_ALL_NEW_BADGES';
export const SET_STREAKS = 'SET_STREAKS';
export const UPDATE_GOAL_SETTINGS = 'UPDATE_GOAL_SETTINGS';
export const SET_NUM_LESSONS_TODAY = 'SET_NUM_LESSONS_TODAY';
export const ADD_COMPLETED_LESSON = 'ADD_COMPLETED_LESSON';
export const REMOVE_COMPLETED_LESSON = 'REMOVE_COMPLETED_LESSON';
export const SET_ORGANIZATION = 'SET_ORGANIZATION';
export const SET_ORGANIZATIONS = 'SET_ORGANIZATIONS';
export const SET_PLEDGES = 'SET_PLEDGES';
export const SET_PLEDGE = 'SET_PLEDGE';
export const SET_PARTICIPANTS = 'SET_PARTICIPANTS';
export const SET_PARTICIPANT_CAMPAIGNS = 'SET_PARTICIPANT_CAMPAIGNS';
export const SET_ORGANIZATION_CAMPAIGNS = 'SET_ORGANIZATION_CAMPAIGNS';
export const SET_WRINKLES = 'SET_WRINKLES';
export const SET_TEST_DRAFT = 'SET_TEST_DRAFT';
export const CLEAR_TEST_DRAFT = 'CLEAR_TEST_DRAFT';
export const SET_PUBLIC_GOALS = 'SET_PUBLIC_GOALS';
export const SET_VERSES = 'SET_VERSES';
export const UPDATE_VERSES = 'UPDATE_VERSES';
export const CLEAR_VERSES_CACHE = 'CLEAR_VERSES_CACHE';
export const SET_LOCALES = 'SET_LOCALES';
export const SET_I18N = 'SET_I18N';
export const SET_I18N_NOTES = 'SET_I18N_NOTES';
export const UPDATE_I18N_NOTES = 'UPDATE_I18N_NOTES';
export const SET_NEW_TRANSLATIONS_RETURN_VALUE = 'SET_NEW_TRANSLATIONS_RETURN_VALUE';
export const SET_READING_BOOKMARK_CHAPTER_ID = 'SET_READING_BOOKMARK_CHAPTER_ID';
export const SET_YEAR_IN_REVIEW_STATS = 'SET_YEAR_IN_REVIEW_STATS';
export const SET_PASSAGE_OF_THE_DAY = 'SET_PASSAGE_OF_THE_DAY';
export const SET_ALL_PASSAGES_OF_THE_DAY = 'SET_ALL_PASSAGES_OF_THE_DAY';
export const ADD_TO_READING_HISTORY = 'ADD_TO_READING_HISTORY';
export const REMOVE_FROM_READING_HISTORY = 'REMOVE_FROM_READING_HISTORY';
export const CLEAR_READING_HISTORY = 'CLEAR_READING_HISTORY';
export const SET_PASSAGE = 'SET_PASSAGE';
export const SET_VERSION_SUPPORT = 'SET_VERSION_SUPPORT';
export const SET_TAGS = 'SET_TAGS';
export const ADD_TO_SUPER_SEARCH_HISTORY = 'ADD_TO_SUPER_SEARCH_HISTORY';
export const REMOVE_FROM_SUPER_SEARCH_HISTORY = 'REMOVE_FROM_SUPER_SEARCH_HISTORY';
export const CLEAR_SUPER_SEARCH_HISTORY = 'CLEAR_SUPER_SEARCH_HISTORY';
export const SET_USER_SETTINGS = 'SET_USER_SETTINGS';
export const SET_THEME = 'SET_THEME';
export const SET_SELECTED_THEME = 'SET_SELECTED_THEME';
export const SET_TIMESTAMP_LAST_ASKED_FOR_REVIEW = 'SET_TIMESTAMP_LAST_ASKED_FOR_REVIEW';
export const SET_GOAL_ASSIGNMENT_SELECTIONS = 'SET_GOAL_ASSIGNMENT_SELECTIONS';
export const SET_GOAL_ASSIGNMENT_SELECTION_REVIEW_PERCENTAGE = 'SET_GOAL_ASSIGNMENT_SELECTION_REVIEW_PERCENTAGE';
export const SET_NOTIFICATION_PREFERENCES = 'SET_NOTIFICATION_PREFERENCES';
export const SET_HTTP_LAST_UPDATED_TIMESTAMP = 'SET_HTTP_LAST_UPDATED_TIMESTAMP';
export const CLEAR_HTTP_LAST_UPDATED_TIMESTAMPS = 'CLEAR_HTTP_LAST_UPDATED_TIMESTAMPS';
export const UPDATE_VERSES_FETCH_TIMESTAMP = 'UPDATE_VERSES_FETCH_TIMESTAMP';
export const SET_DONT_ASK_FOR_PN_PERMS = 'SET_DONT_ASK_FOR_PN_PERMS';
export const GOAL_HIDE_COMPLETED = 'GOAL_HIDE_COMPLETED';
export const GOAL_SHOW_COMPLETED = 'GOAL_SHOW_COMPLETED';

// storm
export const SET_STORM_IS_LIGHTNING_ON = 'SET_STORM_IS_LIGHTNING_ON';
export const SET_STORM_IS_RAIN_ON = 'SET_STORM_IS_RAIN_ON';
export const SET_STORM_IS_THUNDER_ON = 'SET_STORM_IS_THUNDER_ON';
export const ADD_STORM_TIME = 'ADD_STORM_TIME';
export const ADD_STORM_LESSON = 'ADD_STORM_LESSON';
export const CLEAR_STORM_LESSONS = 'CLEAR_STORM_LESSONS';

// schools
export const SET_CLASSROOMS = 'SET_CLASSROOMS';
export const SET_CLASSROOM_STUDENTS = 'SET_CLASSROOM_STUDENTS';
export const SET_CLASSROOM_GOAL = 'SET_CLASSROOM_GOAL';
export const SET_CLASSROOM_GOALS = 'SET_CLASSROOM_GOALS';
export const SET_GOAL_PROGRESS = 'SET_GOAL_PROGRESS';
export const SET_ALL_GOAL_PROGRESS = 'SET_ALL_GOAL_PROGRESS';
export const ADD_ASSIGNMENT_TO_CLASSROOM_GOAL = 'ADD_ASSIGNMENT_TO_CLASSROOM_GOAL';

// admin
export const SET_ADMIN_ANALYTICS = 'SET_ADMIN_ANALYTICS';
export const SET_SCHOOL = 'SET_SCHOOL';
export const SET_SCHOOLS = 'SET_SCHOOLS';
export const SET_MASQUERADE_AS = 'SET_MASQUERADE_AS';
export const CLEAR_MASQUERADE_AS = 'CLEAR_MASQUERADE_AS';
export const SET_API_SYNC_STAGING_METADATA = 'SET_API_SYNC_STAGING_METADATA';

// navigation routes
export const ABOUT_ROUTE_NATIVE = 'About';
export const APP_ROUTE_NATIVE = 'App';
export const ASSIGNMENT_ROUTE_NATIVE = 'Assignment';
export const DISCOVER_ROUTE_NATIVE = 'Discover';
export const FEEDBACK_CHAT_ROUTE_NATIVE = 'FeedbackChat';
export const FRIENDS_ROUTE_NATIVE = 'Friends';
export const FUNDRAISING_ROUTE_NATIVE = 'Fundraising';
export const GOALS_ROUTE_NATIVE = 'Goals';
export const GOAL_ROUTE_NATIVE = 'Goal';
export const GROUPS_ROUTE_NATIVE = 'Groups';
export const HELP_ROUTE_NATIVE = 'Help';
export const LINK_ACCOUNT_ROUTE_NATIVE = 'LinkAccount';
export const NEW_GOAL_ROUTE_NATIVE = 'NewGoal';
export const NOTIFICATIONS_ROUTE_NATIVE = 'Notifications';
export const PRACTICE_ROUTE_NATIVE = 'Practice';
export const PROFILE_ROUTE_NATIVE = 'Profile';
export const READ_ROUTE_NATIVE = 'Read';
export const SETTINGS_ROUTE_NATIVE = 'Settings';
export const WHATS_NEW_ROUTE_NATIVE = 'WhatsNew';
export const WRINKLES_ROUTE_NATIVE = 'Wrinkles';
export const YEAR_IN_REVIEW_ROUTE_NATIVE = 'YearInReview';
export const ABOUT_ROUTE = Platform.OS === 'web' ? '/app/about' : ABOUT_ROUTE_NATIVE;
export const APP_ROUTE = Platform.OS === 'web' ? '/app' : APP_ROUTE_NATIVE;
export const ASSIGNMENT_ROUTE = Platform.OS === 'web' ? '/app/assignment' : ASSIGNMENT_ROUTE_NATIVE;
export const DISCOVER_ROUTE = Platform.OS === 'web' ? '/app/discover' : DISCOVER_ROUTE_NATIVE;
export const FEEDBACK_CHAT_ROUTE = Platform.OS === 'web' ? '/app/feedback-chat' : FEEDBACK_CHAT_ROUTE_NATIVE;
export const FRIENDS_ROUTE = Platform.OS === 'web' ? '/app/friends' : FRIENDS_ROUTE_NATIVE;
export const FUNDRAISING_ROUTE = Platform.OS === 'web' ? '/app/fundraising' : FUNDRAISING_ROUTE_NATIVE;
export const GOALS_ROUTE = Platform.OS === 'web' ? '/app/goals' : GOALS_ROUTE_NATIVE;
export const GOAL_ROUTE = Platform.OS === 'web' ? '/app/goal' : GOAL_ROUTE_NATIVE;
export const GROUPS_ROUTE = Platform.OS === 'web' ? '/app/groups' : GROUPS_ROUTE_NATIVE;
export const HELP_ROUTE = Platform.OS === 'web' ? '/app/help' : HELP_ROUTE_NATIVE;
export const LINK_ACCOUNT_ROUTE = Platform.OS === 'web' ? '/app/link-account' : LINK_ACCOUNT_ROUTE_NATIVE; // @TODO: shouldn't exist on web
export const NEW_GOAL_ROUTE = Platform.OS === 'web' ? '/app/edit-goal' : NEW_GOAL_ROUTE_NATIVE;
export const NOTIFICATIONS_ROUTE = Platform.OS === 'web' ? '/app/settings/notifications' : NOTIFICATIONS_ROUTE_NATIVE;
export const PRACTICE_ROUTE = Platform.OS === 'web' ? '/app/learn' : PRACTICE_ROUTE_NATIVE;
export const PROFILE_ROUTE = Platform.OS === 'web' ? '/app/profile' : PROFILE_ROUTE_NATIVE;
export const READ_ROUTE = Platform.OS === 'web' ? '/app/read' : READ_ROUTE_NATIVE;
export const SETTINGS_ROUTE = Platform.OS === 'web' ? '/app/settings' : SETTINGS_ROUTE_NATIVE;
export const WHATS_NEW_ROUTE = Platform.OS === 'web' ? '/app/whats-new' : WHATS_NEW_ROUTE_NATIVE;
export const WRINKLES_ROUTE = Platform.OS === 'web' ? '/app/wrinkles' : WRINKLES_ROUTE_NATIVE;
export const YEAR_IN_REVIEW_ROUTE = Platform.OS === 'web' ? '/app/year-in-review' : YEAR_IN_REVIEW_ROUTE_NATIVE;

// friends
export const SET_FRIENDS = 'SET_FRIENDS';
export const FOLLOW_USER = 'FOLLOW_USER';
export const UNFOLLOW_USER = 'UNFOLLOW_USER';
export const PUBLIC_USERS_SEARCHED = 'PUBLIC_USERS_SEARCHED';
export const BLOCK_USER = 'BLOCK_USER';
export const UNBLOCK_USER = 'UNBLOCK_USER';
export const SET_LAST_VIEWED_FOLLOWERS_TIMESTAMP = 'SET_LAST_VIEWED_FOLLOWERS_TIMESTAMP';

function _jsDateToMysqlDate(jsDate) {
  if (!jsDate) {
    return null;
  }

  return dateFnsFormat(addMinutes(jsDate, jsDate.getTimezoneOffset()), 'yyyy-MM-dd HH:mm:ss');
}

// action enums
export const BOOK_SORT_METHODS = [
  'bibleOrder',
  'alphabetically',
];

export function clearAllNewBadges() {
  return {
    type: CLEAR_ALL_NEW_BADGES,
  };
}

// @MARK: api calls
export function apiRequestRemoteLogging(subject, body) {
  const formData = new FormData();
  formData.append('subject', subject);
  formData.append('body', body);
  const endpoint = `${globals.apiUrl}/remote_logging`;
  return createApiAction({
    endpoint,
    method: POST,
    body: formData,
    types: getFetchTypes(endpoint, ''),
  });
}

export function apiSaveLesson(userId, uuid, goalId, passageId, assignmentId, difficulty, millisecondsSpent, peanutsEarned, numberOfQuestions, numberOfVerses, minigameIds, repairStreakDate, adHocPassage, testPassedVerseNums, dateCompleted, passageOfTheDayId, streakDateTz, error, numberOfSkippedQuestions, skipFetchesOffline, forceFetchAfterSavingOffline, appVersion) {
  // @TODO: ideally, save lessons in redux before this one so that they're ordered in the db according to completed_date, not this one first THEN ones from redux
  const formData = new FormData();
  formData.append('uuid', uuid);
  if (goalId) {
    formData.append('goal_id', goalId);
  }
  if (passageId) {
    formData.append('passage_id', passageId);
  }
  if (adHocPassage) {
    formData.append('ad_hoc_passage', JSON.stringify(adHocPassage));
  }
  if (testPassedVerseNums) {
    formData.append('test_passed_verse_nums', JSON.stringify(testPassedVerseNums));
  }
  formData.append('difficulty', difficulty);
  if (assignmentId) {
    formData.append('assignment_id', assignmentId);
  }
  formData.append('milliseconds_spent', millisecondsSpent);
  formData.append('peanuts_earned', peanutsEarned);
  formData.append('number_of_questions', numberOfQuestions);
  formData.append('number_of_verses_reviewed', numberOfVerses);
  formData.append('minigame_ids', JSON.stringify(minigameIds));
  formData.append('tz_date', streakDateTz);
  formData.append('date_completed', dateCompleted ?? Date.now());
  if (passageOfTheDayId) {
    formData.append('passage_of_the_day_id', passageOfTheDayId);
  }
  if (repairStreakDate) {
    formData.append('repair_streak_date', repairStreakDate);
  }
  if (error) {
    formData.append('error', error);
  }
  formData.append('number_of_skipped_questions', numberOfSkippedQuestions);
  formData.append('app_version', appVersion);
  const endpoint = `${globals.apiUrl}/lessons`;
  const saveLessonForLaterUpload = (thisDispatch, response) => {
    thisDispatch(addCompletedLesson({ // @TODO: can these args be dynamic by doing `...args`? or actually, make a Lesson class // @TODO: if this ever changes, need to add the exact same args to the addCompletedLesson action...this should be a class object or something so that they're always the same
      userId,
      uuid,
      goalId,
      passageId,
      assignmentId,
      difficulty,
      millisecondsSpent,
      peanutsEarned,
      numberOfQuestions,
      numberOfVerses,
      minigameIds,
      repairStreakDate,
      adHocPassage,
      testPassedVerseNums,
      dateCompleted,
      passageOfTheDayId,
      streakDateTz,
      error: JSON.stringify(response),
      numberOfSkippedQuestions,
      appVersion,
    }));
  };
  return createApiAction({
    endpoint,
    method: POST,
    body: formData,
    types: getFetchTypes(endpoint, skipFetchesOffline ? '' : SET_ASSIGNMENT_PEANUTS),
  }, {
    callback: async (dispatch, response, getState) => {
      if (response.error) {
        // @TODO: this function signature can change between versions, so i think it'd make sense to do something like on error -> if lesson is older than 7 days -> send to me for manual insertion -> delete this lesson (don't save it for retry later)
        saveLessonForLaterUpload(dispatch, response);
      } else {
        /* @TODO: for testing only
        for (let i = 0; i < 4; i++) {
          saveLessonForLaterUpload(dispatch, response);
        }
        console.log('99 saved');
        */
        dispatch(removeCompletedLesson(uuid));
        if (!skipFetchesOffline) {
          const globalReduxStore = getState();
          // @TODO: can most of these calls be replaced by adding more to the response of the save POST?
          if (forceFetchAfterSavingOffline || (globalReduxStore.streaks.current_streak_end_date !== streakDateTz)) {
            // we only need to make this network call if today is not already in the store
            dispatch(fetchStreaks());
          }
          dispatch(fetchSevenDaysPeanuts(userId));
          dispatch(fetchTodaysLessons());
          dispatch(fetchUser()); // @TODO: here for lifetime peanuts/wrinkles only
          if (goalId) {
            // if this is ad-hoc lesson/test, no need to sync goals
            dispatch(fetchGoals());
          }
          if (forceFetchAfterSavingOffline || (!!passageOfTheDayId && !globalReduxStore.passageOfTheDay.isComplete)) {
            // if thisn't isn't a passage-of-the-day lesson (or the passage of the day is already complete), no need to make this network call
            dispatch(fetchPassageOfTheDay());
          }

          if (forceFetchAfterSavingOffline) {
            // since we skipped redux for the ofline saves, fetch everything now
            dispatch(fetchWrinkles());
            dispatch(fetchAssignmentPeanuts());
          }
        }
      }
    },
    onError: async (dispatch) => {
      saveLessonForLaterUpload(dispatch, {message: 'Error saving lesson...probably no internet connection.'});
    },
  });
}

export function fetchTodaysLessons() {
  const midnight = new Date();
  midnight.setHours(0, 0, 0, 0);
  const endpoint = `${globals.apiUrl}/num_lessons_today?users_midnight=${midnight.valueOf()}`;
  return createApiAction({
    endpoint,
    method: GET,
    types: getFetchTypes(endpoint, SET_NUM_LESSONS_TODAY),
  });
}

export function fetchWebStatsNumVersesReviewed() {
  const endpoint = `${globals.apiUrl}/web_stats/num_verses_reviewed`;
  return createApiAction({
    endpoint,
    method: GET,
    types: getFetchTypes(endpoint, SET_VERSES_REVIEWED),
  }, {ignoreAuth: true});
}

export function fetchStreaks() {
  const endpoint = `${globals.apiUrl}/streaks`;
  return createApiAction({
    endpoint,
    method: GET,
    types: getFetchTypes(endpoint, SET_STREAKS),
  });
}

export function repairStreakWithGrace(graceStreakDate) {
  const formData = new FormData();
  formData.append('repair_streak_date', graceStreakDate);
  const endpoint = `${globals.apiUrl}/streaks`;
  return createApiAction({
    endpoint,
    method: POST,
    body: formData,
    types: getFetchTypes(endpoint, SET_STREAKS),
  });
}

export function fetchUserBadges() {
  const endpoint = `${globals.apiUrl}/badges`;
  return createApiAction({
    endpoint,
    method: GET,
    types: getFetchTypes(endpoint, SET_BADGES),
  });
}

export function checkForNewBadges() {
  const endpoint = `${globals.apiUrl}/check_for_new_badges`;
  return createApiAction({
    endpoint,
    method: GET,
    types: getFetchTypes(endpoint, SET_NEW_BADGES),
  });
}

export function fetchWebStatsMsSpent() {
  const endpoint = `${globals.apiUrl}/web_stats/ms_spent`;
  return createApiAction({
    endpoint,
    method: GET,
    types: getFetchTypes(endpoint, SET_MS_SPENT),
  }, {ignoreAuth: true});
}

export function fetchAssignmentPeanuts() {
  const endpoint = `${globals.apiUrl}/assignment_peanuts`;
  return createApiAction({
    endpoint,
    method: GET,
    types: getFetchTypes(endpoint, SET_ALL_ASSIGNMENT_PEANUTS),
  });
}

export function fetchSevenDaysPeanuts(userId) {
  const endpoint = `${globals.apiUrl}/seven_days_peanuts/${userId}`;
  return createApiAction({
    endpoint,
    method: GET,
    types: getFetchTypes(endpoint, SET_SEVEN_DAYS_PEANUTS),
  });
}

export function apiUpdateUser(updatedFields) {
  const formData = new FormData();
  Object.entries(updatedFields).forEach(([k, v]) => {
    formData.append(k, String(v));
  });
  const endpoint = `${globals.apiUrl}/user`;
  return createApiAction({
    endpoint,
    method: PATCH,
    body: formData,
    types: getFetchTypes(endpoint, SET_OAK_USER),
  });
}

export function updateUserSettings(updatedFields) {
  const formData = new FormData();
  Object.entries(updatedFields).forEach(([k, v]) => {
    formData.append(k, String(v));
  });
  const endpoint = `${globals.apiUrl}/user/settings`;
  return createApiAction({
    endpoint,
    method: PATCH,
    body: formData,
    types: getFetchTypes(endpoint, SET_USER_SETTINGS),
  }, {callback: async (dispatch) => {
    if (Object.keys(updatedFields).includes('preferred_translation_id')) {
      // in case we're offline, setting preferred translation id will save it to local storage to still work without updating back end
      dispatch(setPreferredTranslationId(updatedFields.preferred_translation_id));
    }
  }});
}

export function apiCreateClassroomGoal(classroomId, goalTitle, dateAvailable, dateDeadline, callback) { // @TODO: rename actions...don't need to prepend with api
  const insertJson = {
    title: goalTitle,
    date_available: _jsDateToMysqlDate(dateAvailable),
    date_deadline: _jsDateToMysqlDate(dateDeadline),
  };
  const endpoint = `${globals.apiUrl}/classrooms/${classroomId}/goals`;
  return createApiAction({
    endpoint,
    method: POST,
    body: JSON.stringify(insertJson),
    headers: JSON_HEADERS,
    types: getFetchTypes(endpoint, SET_CLASSROOM_GOAL),
  }, {callback: async (__dispatch, response) => {
    if (!response.error) {
      callback?.(response.payload.goal.id);
      /* @TODO: why did i think this was a good idea? on create, there will be no progress...especially cause it's not even published. but also this response doesn't contain a goal id, so i don't know why this is here...
      dispatch(fetchGoalProgress(response.payload.goal.id));
      */
    } // @TODO: else show error
  }});
}

export function apiAdminCreateClassroomGoal(classroomId, pipeDelimitedText) { // @TODO: rename actions...don't need to prepend with api
  const endpoint = `${globals.apiUrl}/admin/classrooms/${classroomId}/goals`;
  return createApiAction({
    endpoint,
    method: POST,
    body: JSON.stringify({pipe_delimited_text: pipeDelimitedText}),
    headers: JSON_HEADERS,
    types: getFetchTypes(endpoint, SET_CLASSROOM_GOAL),
  });
}

export function apiUpdateGoal(goalId, goalTitle, goalDescription, goalType, moduleIds, passageIds, dateAvailable, dateDeadline, callbackToDispatch, status, callback) { // @TODO: web uses moduleIds, mobile uses passageIds...these should probably be combined, at least when group/reading goals are editable client-side // @TODO: this needs to change to moduleIds? // @TODO: seems like callbackToDispatch is only being used to fetch wrinkles...maybe just make that part of the response?
  const updateJson = {} as any;
  if (goalTitle) {
    updateJson.title = goalTitle;
  }
  if (goalDescription) {
    updateJson.description = goalDescription;
  }
  if (goalType) {
    updateJson.goal_type = goalType;
  }
  if (moduleIds) {
    updateJson.module_order = moduleIds;
  }
  if (passageIds) {
    updateJson.passage_ids = passageIds;
  }
  if (dateAvailable !== undefined) { // null is a valid value
    updateJson.date_available = dateAvailable ? _jsDateToMysqlDate(dateAvailable) : null;
  }
  if (dateDeadline !== undefined) { // null is a valid value
    updateJson.date_deadline = dateDeadline ? _jsDateToMysqlDate(dateDeadline) : null;
  }
  if (status) {
    updateJson.status = status;
  }
  // @TODO: if no key/value pairs in json, don't make request
  const endpoint = `${globals.apiUrl}/goals/${goalId}`;
  return createApiAction({
    endpoint,
    method: PATCH,
    body: JSON.stringify(updateJson),
    headers: JSON_HEADERS,
    types: getFetchTypes(endpoint, SET_GOAL),
  }, {loadingStateToTrack: 'apiUpdateGoal', callback: async (dispatch) => {
    if (callbackToDispatch) {
      dispatch(callbackToDispatch());
    }
    if (callback) {
      callback();
    }
  }});
}

export function apiUpdateClassroomGoal(classroomId, goalId, updateKeyValues, userIdsToAssign = undefined) {
  const updateJson = {} as any;
  if (updateKeyValues.status) {
    updateJson.status = updateKeyValues.status;
  }
  if (updateKeyValues.canChooseTranslation !== undefined) {
    updateJson.can_choose_translation = +updateKeyValues.canChooseTranslation;
  }
  if (updateKeyValues.isPublic !== undefined) {
    updateJson.is_public = +updateKeyValues.isPublic;
  }
  if (userIdsToAssign) {
    updateJson.user_ids_to_assign = userIdsToAssign;
  }
  // @TODO: if no key/value pairs in json, don't make request...maybe do in bailout?
  const endpoint = `${globals.apiUrl}/classrooms/${classroomId}/goals/${goalId}`;
  return createApiAction({
    endpoint,
    method: PATCH,
    body: JSON.stringify(updateJson),
    headers: JSON_HEADERS,
    types: getFetchTypes(endpoint, SET_CLASSROOM_GOAL),
  });
}

export function apiUpdateClassroom(classroomId, isJoinCodeEnabled) {
  const updateJson = {
    is_join_code_enabled: +isJoinCodeEnabled,
  };
  const endpoint = `${globals.apiUrl}/classrooms/${classroomId}`;
  return createApiAction({
    endpoint,
    method: PATCH,
    body: JSON.stringify(updateJson),
    headers: JSON_HEADERS,
    types: getFetchTypes(endpoint, SET_CLASSROOMS),
  });
}

export function apiSaveGoal(goalTitle, passageIds, callback) {
  const updateJson = {} as any;
  updateJson.goal_title = goalTitle;
  updateJson.passage_ids = passageIds;
  const endpoint = `${globals.apiUrl}/goals`;
  return createApiAction({
    endpoint,
    method: POST,
    body: JSON.stringify(updateJson),
    headers: JSON_HEADERS,
    types: getFetchTypes(endpoint, SET_GOAL),
  }, {loadingStateToTrack: 'apiSaveGoal', callback: async (dispatch, response) => {
    if (response.payload.new_goal_id) {
      // this should always be true, but in case there's a network error, check the conditional
      dispatch(setActiveGoalId(response.payload.new_goal_id));
      callback?.();
    }
  }});
}

export function apiSavePublicGoal(publicGoalId, preferredTranslationId) {
  const insertJson = {
    public_goal_id: publicGoalId,
    translation_id: preferredTranslationId,
  };
  const endpoint = `${globals.apiUrl}/user_goals`;
  return createApiAction({
    endpoint,
    method: POST,
    body: JSON.stringify(insertJson),
    headers: JSON_HEADERS,
    types: getFetchTypes(endpoint, SET_GOAL),
  }, {callback: async (dispatch, response) => {
    if (response.payload.new_goal_id) {
      // this should always be true, but in case there's a network error, check the conditional
      dispatch(setActiveGoalId(response.payload.new_goal_id));
    }
  }});
}

export function apiDeleteGoal(goalId) {
  const endpoint = `${globals.apiUrl}/goals/${goalId}`;
  return createApiAction({
    endpoint,
    method: DELETE,
    types: getFetchTypes(endpoint, SET_GOALS),
  });
}

export function addCompletedLesson(lesson) {
  return {
    type: ADD_COMPLETED_LESSON,
    lesson,
  };
}

export function removeCompletedLesson(uuid) {
  return {
    type: REMOVE_COMPLETED_LESSON,
    uuid,
  };
}

export function updateGoalSettings(updatedSettings) {
  return {
    type: UPDATE_GOAL_SETTINGS,
    updatedSettings,
  };
}

// @MARK: fundraising
export function fetchOrganizations() {
  const endpoint = `${globals.apiUrl}/organizations`; // @TODO: "?publicOnly=1" should probbly be included
  return createApiAction({
    endpoint,
    method: GET,
    body: null,
    types: getFetchTypes(endpoint, SET_ORGANIZATIONS),
  }, {ignoreAuth: true});
}

export function fetchOrganization(organizationSlug) {
  const endpoint = `${globals.apiUrl}/organizations/${organizationSlug}`; // @TODO: "?withCampaigns=1" should probbly be included
  return createApiAction({
    endpoint,
    method: GET,
    body: null,
    types: getFetchTypes(endpoint, SET_ORGANIZATION),
  }, {ignoreAuth: true});
}

export function fetchPledges(organizationId, campaignId) {
  const endpoint = `${globals.apiUrl}/organizations/${organizationId}/campaigns/${campaignId}/pledges`;
  return createApiAction({
    endpoint,
    method: GET,
    types: getFetchTypes(endpoint, SET_PLEDGES),
  }, {ignoreAuth: true}); // @TODO: shouldn't be true...jwt needs to be included, but currently only configured for mobile
}

export function fetchPledgeForToken(token) {
  const endpoint = `${globals.apiUrl}/pledges/${token}`;
  return createApiAction({
    endpoint,
    method: GET,
    types: getFetchTypes(endpoint, SET_PLEDGE),
  }, {ignoreAuth: true}); // @TODO: shouldn't be true...jwt needs to be included, but currently only configured for mobile
}

export function fetchParticipants(organizationId, campaignId) {
  const endpoint = `${globals.apiUrl}/organizations/${organizationId}/campaigns/${campaignId}/participants`;
  return createApiAction({
    endpoint,
    method: GET,
    types: getFetchTypes(endpoint, SET_PARTICIPANTS),
  }, {ignoreAuth: true}); // @TODO: shouldn't be true...jwt needs to be included, but currently only configured for mobile
}

export function inviteParticipants(organizationId, campaignId, participants) {
  const endpoint = `${globals.apiUrl}/organizations/${organizationId}/campaigns/${campaignId}/participants`;
  return createApiAction({
    endpoint,
    method: POST,
    body: JSON.stringify({participants}),
    headers: JSON_HEADERS,
    types: getFetchTypes(endpoint, SET_PARTICIPANTS),
  });
}

export function fetchUser(localeId = null) {
  let getArgs = `?tz_offset=${new Date().getTimezoneOffset()}`; // @TODO: use a lib (built-in?) to create getArgs without building manually
  if (localeId) {
    getArgs = `${getArgs}&locale_id=${localeId}`;
  }
  const endpoint = `${globals.apiUrl}/user${getArgs}`;
  return createApiAction({
    endpoint,
    method: GET,
    types: getFetchTypes(endpoint, SET_OAK_USER),
  });
}

export function fetchBooks() { // @TODO: this is currently conditionally fetched on mobile...do the same thing for web
  const lastUpdated = store.getState().httpLastUpdatedTimestamps.books || 0;
  const endpoint = `${globals.apiUrl}/books?last_updated=${lastUpdated}`;
  return createApiAction({
    endpoint,
    method: GET,
    body: null,
    types: getFetchTypes(endpoint, SET_BOOKS),
  }, {
    ignoreAuth: true,
    callback: async (dispatch) => dispatch(setHttpLastUpdatedTimestamp('books', Date.now())), // @TODO: global const
  });
}

export function fetchBookNames() {
  const lastUpdated = store.getState().httpLastUpdatedTimestamps.book_names || 0;
  const endpoint = `${globals.apiUrl}/book_names?last_updated=${lastUpdated}`;
  return createApiAction({
    endpoint,
    method: GET,
    body: null,
    types: getFetchTypes(endpoint, SET_BOOK_NAMES),
  }, {
    ignoreAuth: true,
    callback: async (dispatch) => dispatch(setHttpLastUpdatedTimestamp('book_names', Date.now())), // @TODO: global const
  });
}

export function fetchChapters() { // @TODO: this is currently conditionally fetched on mobile...do the same thing for web
  const lastUpdated = store.getState().httpLastUpdatedTimestamps.chapters || 0;
  const endpoint = `${globals.apiUrl}/chapters?last_updated=${lastUpdated}`;
  return createApiAction({
    endpoint,
    method: GET,
    body: null,
    types: getFetchTypes(endpoint, SET_CHAPTERS),
  }, {
    ignoreAuth: true,
    callback: async (dispatch) => dispatch(setHttpLastUpdatedTimestamp('chapters', Date.now())), // @TODO: global const
  });
}

export function fetchTranslations() {
  // @TODO: don't re-fetch if already in redux...maybe make api call with a timestamp of last updated, and back end can handle it as needed
  const endpoint = `${globals.apiUrl}/translations`;
  return createApiAction({
    endpoint,
    method: GET,
    body: null,
    types: getFetchTypes(endpoint, SET_TRANSLATIONS),
  }, {ignoreAuth: true});
}

export function fetchGoals() {
  const endpoint = `${globals.apiUrl}/goals`;
  return createApiAction({
    endpoint,
    method: GET,
    body: null,
    types: getFetchTypes(endpoint, SET_GOALS),
  }, {loadingStateToTrack: 'fetchGoals', callback: async (dispatch, response, getState) => {
    if (!response.error) {
      const globalReduxStore = getState();
      // @TODO: too expensive to fetch progress for all goals, but let's fetch the current goal since that's the one that was likely just updated
      const activeGoalId = globalReduxStore.settingsActiveGoalId || response.payload.goals[0]?.id || 20320; // @TODO: don't like hardcoding 20320 here, but activeGoalId may be null
      if (response.payload.goals.length) {
      // @TODO: if (response.payload.goals.length && !globalReduxStore.settingsActiveGoalId) {
        await dispatch(setActiveGoalId(activeGoalId));
      }
      dispatch(fetchUserGoalProgress(activeGoalId));
    } // @TODO: else show error
    /* @TODO: this is too unperformant to do here...goals are fetched very frequently
    response.payload.goals.forEach((goal) => {
      if (goal.classroom_goal_metadata.classroom_id && goal.user_goal.status === 'active') {
        // this is an active classroom goal, so it's progress is sent from the back end
        // @TODO: don't need to fetch for oakwood public that are verse memories only
        // @TODO: don't need to fetch if goal is completed
        // @TODO: console.log(`fetching for ${goal.title} (${goal.id})`);
        dispatch(fetchUserGoalProgress(goal.id));
      }
    });
    */
  }});
}

export function fetchGoalPreview(previewGoalId, translationId) {
  const endpoint = `${globals.apiUrl}/public_goals/${previewGoalId}/preview?translation_id=${translationId}`;
  return createApiAction({
    endpoint,
    method: GET,
    body: null,
    types: getFetchTypes(endpoint, SET_GOAL_PREVIEW),
  });
}

export function fetchUpdatedVerses() { // @TODO: update this (currently not fetching any updated verses which is fine for now)
  return async (__dispatch, __getState) => { // @TODO: replace with createApiAction
    /* @TODO:
    const globalReduxStore = getState();
    if (Object.keys(globalReduxStore.verses).length) { // @TODO: this shouldn't do the actual fetching...only a ping to see if there's stuff to fetch
      // no reason to call this on first open or if there are no verses in the redux store
      const endpoint = `${globals.apiUrl}/translations/${Object.keys(globalReduxStore.verses).join(',')}/updated_verses?verses_last_updated_timestamp=${globalReduxStore.versesLastUpdatedTimestamp}`;
      const response = await dispatch({
        [RSAA]: {
          endpoint,
          method: GET,
          headers: await getRequestHeaders(),
          types: getFetchTypes(endpoint, UPDATE_VERSES),
        },
      });
      if (!response.error) {
        dispatch(setVersesLastUpdated());
      }
    }
    */
  };
}

export function setVersesLastUpdated() {
  return {
    type: SET_VERSES_LAST_UPDATED,
  };
}

export function toggleMinigameActive(minigameId) {
  return {
    type: TOGGLE_MINIGAME_ACTIVE,
    minigameId,
  };
}

export function setActiveGoalId(goalId) {
  return {
    type: SET_ACTIVE_GOAL_ID,
    goalId,
  };
}

// @MARK: settings
export function setPreferredTranslationId(preferredTranslationId) {
  return {
    type: SET_PREFERRED_TRANSLATION_ID,
    preferredTranslationId,
  };
}

export function setPreferredScale(preferredScale) {
  return {
    type: SET_PREFERRED_SCALE,
    preferredScale,
  };
}

export function setPreferredVerseSelectionMethod(preferredVerseSelectionMethod) {
  return {
    type: SET_PREFERRED_VERSE_SELECTION_METHOD,
    preferredVerseSelectionMethod,
  };
}

export function setBookSortMethod(sortMethod) {
  return {
    type: SET_BOOK_SORT_METHOD,
    sortMethod,
  };
}

export function setShowBadgesInRead(showBadgesInRead) {
  return {
    type: SET_SHOW_BADGES_IN_READ,
    showBadgesInRead,
  };
}

export function addWrinkly101(translationId) {
  const formData = new FormData();
  formData.append('translation_id', translationId);
  const endpoint = `${globals.apiUrl}/wrinkly_101`;
  return createApiAction({ // @TODO: if this fails, need to alert user
    endpoint,
    method: POST,
    body: formData,
    types: getFetchTypes(endpoint, SET_GOAL),
  }, {loadingStateToTrack: 'addWrinkly101', callback: async (dispatch, response) => {
    await saveVersesToDb(dispatch, response);
    if (!response.error) {
      dispatch(fetchAllUserGoalProgress());
    }
  }});
}

export function uploadImage(base64Image, url, callback) {
  const formData = new FormData();
  formData.append('file', base64Image);
  const endpoint = url;
  return createApiAction({
    endpoint,
    method: PUT,
    body: formData,
    types: getFetchTypes(endpoint, ''), // @TODO: need a success action type? probably not...
  }, {callback: async () => callback()});
}

// @MARK: fundraising
export function saveSponsorAndPledge(displayName, email, campaignId, centsPerWrinkle, maxDonationCents, stripePaymentMethodId) {
  const formData = new FormData();
  formData.append('display_name', displayName);
  formData.append('email', email);
  formData.append('campaign_id', campaignId);
  formData.append('cents_per_wrinkle', centsPerWrinkle);
  formData.append('max_donation_cents', maxDonationCents);
  formData.append('stripe_payment_method_id', stripePaymentMethodId);
  const endpoint = `${globals.apiUrl}/pledges`;
  return createApiAction({
    endpoint,
    method: POST,
    body: formData,
    types: getFetchTypes(endpoint, ''), // @TODO: save something in redux instead of optimistic rendering of success message?
  }, {ignoreAuth: true}); // @TODO: it's possible the user is logged in...jwt optional?
}

export function fetchOrganizationCampaigns() {
  const endpoint = `${globals.apiUrl}/organization_campaigns`;
  return createApiAction({
    endpoint,
    method: GET,
    types: getFetchTypes(endpoint, SET_ORGANIZATION_CAMPAIGNS),
  });
}

export function fetchParticipantCampaigns() {
  const endpoint = `${globals.apiUrl}/participant_campaigns`;
  return createApiAction({
    endpoint,
    method: GET,
    types: getFetchTypes(endpoint, SET_PARTICIPANT_CAMPAIGNS),
  });
}

export function joinFundraisingCampaign(invitationCode, callback) {
  const endpoint = `${globals.apiUrl}/join_campaign`;
  const formData = new FormData();
  formData.append('invitation_code', invitationCode);
  return createApiAction({
    endpoint,
    method: POST,
    body: formData,
    types: getFetchTypes(endpoint, SET_PARTICIPANT_CAMPAIGNS),
  }, {callback: async (__dispatch, response) => {
    callback(response.error, response.payload.message);
  }});
}

// @MARK: wrinkles
export function fetchWrinkles() {
  const endpoint = `${globals.apiUrl}/wrinkles`;
  return createApiAction({
    endpoint,
    method: GET,
    types: getFetchTypes(endpoint, SET_WRINKLES),
  });
}

export function updateWrinkle(wrinkleId, isPaused) {
  const endpoint = `${globals.apiUrl}/wrinkles/${wrinkleId}`;
  const formData = new FormData();
  formData.append('is_paused', String(+isPaused));
  return createApiAction({
    endpoint,
    method: PATCH,
    body: formData,
    types: getFetchTypes(endpoint, SET_WRINKLES), // @TODO: shouldn't have to recalculate all wrinkles...just this one
  });
}

// @MARK: friends
export function fetchFriends() {
  const endpoint = `${globals.apiUrl}/friends`;
  return createApiAction({
    endpoint,
    method: GET,
    types: getFetchTypes(endpoint, SET_FRIENDS),
  });
}

export function fetchPublicUser(userId) {
  const endpoint = `${globals.apiUrl}/users/${userId}`;
  return createApiAction({
    endpoint,
    method: GET,
    types: getFetchTypes(endpoint, PUBLIC_USERS_SEARCHED), // @TODO: this used to be FOLLOW_USER...make sure there are no regressions (especially in web)
  });
}

export function followUser(userId) {
  const endpoint = `${globals.apiUrl}/users/${userId}/follow`;
  return createApiAction({
    endpoint,
    method: POST,
    types: getFetchTypes(endpoint, FOLLOW_USER),
  }, {loadingStateToTrack: 'followUser', loadingStateMetadata: {userId}});
}

export function unfollowUser(userId) {
  const endpoint = `${globals.apiUrl}/users/${userId}/unfollow`;
  return createApiAction({
    endpoint,
    method: POST,
    types: getFetchTypes(endpoint, UNFOLLOW_USER),
  });
}

export function blockUser(userId) {
  const endpoint = `${globals.apiUrl}/users/${userId}/block`;
  return createApiAction({
    endpoint,
    method: POST,
    types: getFetchTypes(endpoint, BLOCK_USER),
  });
}

export function unblockUser(userId) {
  const endpoint = `${globals.apiUrl}/users/${userId}/unblock`;
  return createApiAction({
    endpoint,
    method: POST,
    types: getFetchTypes(endpoint, UNBLOCK_USER),
  });
}

export function reportUser(userId, reason) {
  const endpoint = `${globals.apiUrl}/users/${userId}/report`;
  const formData = new FormData();
  formData.append('reason', reason);
  return createApiAction({
    endpoint,
    method: POST,
    body: formData,
    types: getFetchTypes(endpoint, ''),
  }, {callback: async (dispatch) => {
    dispatch(fetchFriends());
  }});
}

export function setLastViewedFollowersTimestamp(timestamp) {
  return {
    type: SET_LAST_VIEWED_FOLLOWERS_TIMESTAMP,
    timestamp,
  };
}

export function reportTest(passageId, reference, correctText, rawText, diffs, reportNotes) {
  const formData = new FormData();
  formData.append('passage_id', passageId);
  formData.append('reference', reference);
  formData.append('correct_text', correctText);
  formData.append('raw_text', rawText);
  formData.append('diffs', JSON.stringify(diffs));
  formData.append('report_notes', reportNotes);
  const endpoint = `${globals.apiUrl}/report_test`;
  return createApiAction({
    endpoint,
    method: POST,
    body: formData,
    types: getFetchTypes(endpoint, ''),
  });
}

export function setTestDraft(passageId, text, msSpent) {
  return {
    type: SET_TEST_DRAFT,
    passageId,
    text,
    msSpent,
  };
}

export function clearTestDraft(passageId) {
  return {
    type: CLEAR_TEST_DRAFT,
    passageId,
  };
}

export function fetchPublicGoals() {
  const endpoint = `${globals.apiUrl}/public_goals`;
  return createApiAction({
    endpoint,
    method: GET,
    types: getFetchTypes(endpoint, SET_PUBLIC_GOALS),
  });
}

// @TODO: let setTimestamp = 0;
// @TODO: let dispatchCount = 0;
export function fetchVerses(translationId, bookId = undefined, chapterNum = undefined, missingVerseNums = undefined, endpoint = undefined, callback = undefined) {
  // @TODO: dispatchCount++;
  // @TODO: console.log({dispatchCount});
  const ACTION_CREATOR_NAME = 'fetchVerses';
  endpoint = endpoint || `${globals.apiUrl}/translations/${translationId}/verses`;
  if (missingVerseNums?.length) {
    endpoint = `${globals.apiUrl}/translations/${translationId}/books/${bookId}/chapters/${chapterNum}/verses/${missingVerseNums.join(',')}`;
  }
  return createApiAction({
    endpoint,
    method: GET,
    types: getFetchTypes(endpoint, SET_VERSES, false, null, ACTION_CREATOR_NAME), // @TODO: toast network errors
    bailout: (state) => {
      // only bail if previous request is in flight (errors should be retried, and ignore successes because they're probably old...not ignoring success causes issue with clearing cache and refetching active passages in same session)
      return !!Object.values(state.fetches).find((f: any) => f.endpoint === endpoint && f.status === FETCH_REQUEST_OBJECT.status);
    },
  }, {callback: async (dispatch, response, __getState) => { // @TODO: loadingStateToTrack?
    await saveVersesToDb(dispatch, response);
    if (response?.payload.next_page) { // @NOTE: `response` will be `undefined` if `bailout` above is executed, so do a null-check here
      dispatch(fetchVerses(translationId, bookId, chapterNum, missingVerseNums, response.payload.next_page, callback));
    } else if (response) {
      // this is the last call in this request
      callback?.();
      // @TODO: set isFullDownload bool if full download (translationId is only arg?)
      // @TODO: if (!Object.values(getState().fetches).find((f) => f.actionCreatorName === ACTION_CREATOR_NAME && f.status === FETCH_REQUEST_OBJECT.status)) {
      // there are no more verse requests in flight (even for other passages), so we can update the timestamp to force a re-render for components that need the verse(s)
      // @TODO: we used to set a last-fetch timestamp that useGetVersesForPassages listened to, but now we're using useTypedSelector in that hook
      // @TODO: }
    }
  }});
}

async function saveVersesToDb(dispatch, response) {
    // @TODO: VerseText model should have same shape as return json (but change to protobuf...can these models be the same?)
    if (!response.payload.verses || !response.payload.verses.length) {
      return;
    }

    await Translation.upsertAll(db, [{translation_id: response.payload.verses[0].translation_id, isFullDownload: false}]);
    await VerseText.upsertAll(db, response.payload.verses);

    dispatch({type: UPDATE_VERSES_FETCH_TIMESTAMP});
}

export function fetchVersesBatched(references) {
  // @TODO: this needs to make sure that references.length isn't large enough that the request/response needs to be paginated
  const endpoint = `${globals.apiUrl}/batched_text_request`;
  return createApiAction({
    endpoint,
    method: POST,
    body: JSON.stringify({references}),
    headers: JSON_HEADERS,
    types: getFetchTypes(endpoint, SET_VERSES), // @TODO: toast network errors
    /* @TODO: need a bailout? is it possible for more than one request to be made simultaneously?
    bailout: (state) => {
      // only bail if previous request is in flight (errors should be retried, and ignore successes because they're probably old...not ignoring success causes issue with clearing cache and refetching active passages in same session)
      return !!Object.values(state.fetches).find((f) => f.endpoint === endpoint && f.status === FETCH_REQUEST_OBJECT.status);
    },
    */
  }, {
    ignoreAuth: true, // @TODO: need to ignore auth for passages shared in web landing page, but this should probably be authenticated...make new route for that? or maybe just give this an api key (not secure cause it's in the front end though...)
    callback: async (dispatch, response) => {
      await saveVersesToDb(dispatch, response);
      /* @TODO: instead of paginating like this, probably just chunk the references arg into smaller requests and loop over them to make separate calls
      if (response?.payload.next_page) { // @NOTE: `response` will be `undefined` if `bailout` above is executed, so do a null-check here
        dispatch(fetchVerses(translationId, bookId, chapterNum, missingVerseNums, response.payload.next_page));
      }
      */
    },
  });
}

export function addToReadingHistory(chapterId) {
  return {
    type: ADD_TO_READING_HISTORY,
    chapterId,
  };
}

export function removeFromReadingHistory(chapterId) {
  return {
    type: REMOVE_FROM_READING_HISTORY,
    chapterId,
  };
}

export function clearReadingHistory() {
  return {
    type: CLEAR_READING_HISTORY,
  };
}

export function clearLocalVersesForTranslationId(translationId) {
  return async () => {
    await VerseText.deleteAllByTranslationId(db, translationId); // @TODO: maybe this should be called by a Translation static method? called Translation.deleteTranslation and it cascades to this?
    await Translation.upsertAll(db, [{translation_id: translationId, isFullDownload: false}]);

    return {
      type: CLEAR_VERSES_CACHE,
      translationId: translationId, // @TODO: there's a reason why i'm ignoring this eslint warning i think...just can't remember why...if it's null, the key is missing instead of only the value being null, but that doesn't seem to apply here...
    };
  };
}

export function fetchLocales() {
  const endpoint = `${globals.apiUrl}/locales`;
  return createApiAction({
    endpoint,
    method: GET,
    types: getFetchTypes(endpoint, SET_LOCALES),
  }, {
    ignoreAuth: true,
  });
}

export function setHttpLastUpdatedTimestamp(route, timestamp) {
  return {
    type: SET_HTTP_LAST_UPDATED_TIMESTAMP,
    route,
    timestamp,
  };
}

export function fetchI18n(localeId, includeArchived = false, forceFetch = false) {
  const lastUpdated = store.getState().httpLastUpdatedTimestamps.i18n || 0;
  let endpoint = `${globals.apiUrl}/i18n/${localeId}?include_archived=${includeArchived ? 1 : 0}`;
  if (!forceFetch) {
    endpoint = `${endpoint}&last_updated=${lastUpdated}`;
  }
  return createApiAction({
    endpoint,
    method: GET,
    types: getFetchTypes(endpoint, SET_I18N),
  }, {
    ignoreAuth: true,
    loadingStateToTrack: 'fetchI18n',
    callback: async (dispatch) => dispatch(setHttpLastUpdatedTimestamp('i18n', Date.now())), // @TODO: global const for i18n string
  }); // @TODO: maybe this should require auth, but the auth page has it preinstalled?
}

export function fetchI18nNotes(localeId) {
  const endpoint = `${globals.apiUrl}/i18n/notes?locale_id=${localeId}`;
  return createApiAction({
    endpoint,
    method: GET,
    types: getFetchTypes(endpoint, SET_I18N_NOTES),
  });
}

export function addI18nNote(i18nId, upvoted, notes = undefined) {
  const endpoint = `${globals.apiUrl}/i18n/notes`;
  const formData = new FormData();
  formData.append('i18n_id', i18nId);
  if (upvoted !== null) {
    formData.append('upvoted', String(upvoted ? 1 : 0));
  }
  if (notes) {
    formData.append('notes', notes);
  }
  return createApiAction({
    endpoint,
    method: POST,
    body: formData,
    types: getFetchTypes(endpoint, UPDATE_I18N_NOTES),
  });
}

export function updateI18nValue(i18nId, newValue) {
  const formData = new FormData();
  formData.append('new_value', newValue);
  const endpoint = `${globals.apiUrl}/i18n/${i18nId}`;
  return createApiAction({
    endpoint,
    method: PUT,
    body: formData,
    types: getFetchTypes(endpoint, SET_I18N),
  });
}

export function saveNewTranslations(newTranslationsStringifiedJson) {
  const endpoint = `${globals.apiUrl}/i18n`;
  return createApiAction({
    endpoint,
    method: POST,
    body: newTranslationsStringifiedJson,
    headers: JSON_HEADERS,
    types: getFetchTypes(endpoint, SET_NEW_TRANSLATIONS_RETURN_VALUE),
  });
}

export function postAdditionalDonation(token, additionalDonationCents) {
  const updateJson = {} as any;
  updateJson.token = token;
  updateJson.additional_donation_cents = additionalDonationCents;
  const endpoint = `${globals.apiUrl}/pledges`;
  return createApiAction({
    endpoint,
    method: PATCH,
    body: JSON.stringify(updateJson),
    headers: JSON_HEADERS,
    types: getFetchTypes(endpoint, SET_PLEDGE),
  });
}

export function setReadingBookmarkChapterId(chapterId) {
  return {
    type: SET_READING_BOOKMARK_CHAPTER_ID,
    chapterId,
  };
}

export function upsertYearInReview(year) {
  const endpoint = `${globals.apiUrl}/year_in_review/${year}`;
  return createApiAction({
    endpoint,
    method: POST,
    types: getFetchTypes(endpoint, SET_YEAR_IN_REVIEW_STATS),
  }, {loadingStateToTrack: 'upsertYearInReview'});
}

export function fetchAllPassagesOfTheDay() {
  const endpoint = `${globals.apiUrl}/admin/all_passages_of_the_day`;
  return createApiAction({
    endpoint,
    method: GET,
    types: getFetchTypes(endpoint, SET_ALL_PASSAGES_OF_THE_DAY),
  });
}

export function addNewPassagesOfTheDay(passagesText) {
  const endpoint = `${globals.apiUrl}/admin/passages_of_the_day`;
  const formData = new FormData();
  formData.append('passages_text', passagesText);
  return createApiAction({
    endpoint,
    method: POST,
    body: formData,
    types: getFetchTypes(endpoint, SET_ALL_PASSAGES_OF_THE_DAY),
  });
}

export function fetchPassageOfTheDay() {
  const endpoint = `${globals.apiUrl}/passage_of_the_day?user_date=${dateFnsFormat(new Date(), 'yyyy-MM-dd')}`;
  return createApiAction({
    endpoint,
    method: GET,
    types: getFetchTypes(endpoint, SET_PASSAGE_OF_THE_DAY),
  });
}

export function fetchMyClassroomsStudent() {
  const endpoint = `${globals.apiUrl}/student_classrooms`;
  return createApiAction({
    endpoint,
    method: GET,
    types: getFetchTypes(endpoint, SET_CLASSROOMS),
  });
}

export function joinClassroom(joinCode, callback) {
  const endpoint = `${globals.apiUrl}/classrooms/join`;
  const formData = new FormData();
  formData.append('join_code', joinCode);
  return createApiAction({
    endpoint,
    method: POST,
    body: formData,
    types: getFetchTypes(endpoint, SET_CLASSROOMS),
  }, {callback: async (__dispatch, response) => {
    callback(response.error, response.payload.message);
  }});
}

export function fetchPassage(passageId) {
  const endpoint = `${globals.apiUrl}/passages/${passageId}`;
  return createApiAction({
    endpoint,
    method: GET,
    types: getFetchTypes(endpoint, SET_PASSAGE),
  });
}

export function fetchMinigames() {
  const endpoint = `${globals.apiUrl}/minigames`;
  return createApiAction({
    endpoint,
    method: GET,
    body: null,
    types: getFetchTypes(endpoint, SET_MINIGAMES),
  });
}

export function fetchVersionSupport() {
  const endpoint = `${globals.apiUrl}/version_support`;
  return createApiAction({
    endpoint,
    method: GET,
    body: null,
    types: getFetchTypes(endpoint, SET_VERSION_SUPPORT),
  }, {ignoreAuth: true});
}

export function apiUpdateGoalTags(classroomId, goalId, tags) {
  const updateJson = {
    tags,
  };
  const endpoint = `${globals.apiUrl}/classrooms/${classroomId}/goals/${goalId}/tags`;
  return createApiAction({
    endpoint,
    method: PATCH,
    body: JSON.stringify(updateJson),
    headers: JSON_HEADERS,
    types: getFetchTypes(endpoint, SET_CLASSROOM_GOAL),
  });
}

export function addToSuperSearchHistory(searchText) {
  return {
    type: ADD_TO_SUPER_SEARCH_HISTORY,
    searchText,
  };
}

export function removeFromSuperSearchHistory(searchText) {
  return {
    type: REMOVE_FROM_SUPER_SEARCH_HISTORY,
    searchText,
  };
}

export function clearSuperSearchHistory() {
  return {
    type: CLEAR_SUPER_SEARCH_HISTORY,
  };
}

export function fetchGoalProgress(classroomId, goalId) { // @TODO: should be in schools actions file
  const endpoint = `${globals.apiUrl}/classrooms/${classroomId}/goals/${goalId}/progress`;
  return createApiAction({
    endpoint,
    method: GET,
    types: getFetchTypes(endpoint, SET_GOAL_PROGRESS),
  });
}

export function fetchAllUserGoalProgress() {
  const endpoint = `${globals.apiUrl}/goals/progress`;
  return createApiAction({
    endpoint,
    method: GET,
    types: getFetchTypes(endpoint, SET_ALL_GOAL_PROGRESS),
  });
}

export function fetchUserGoalProgress(goalId) {
  const endpoint = `${globals.apiUrl}/goals/${goalId}/progress`;
  return createApiAction({
    endpoint,
    method: GET,
    types: getFetchTypes(endpoint, SET_GOAL_PROGRESS),
  });
}

export function setTheme(theme) {
  return {
    type: SET_THEME,
    theme,
  };
}

// @NOTE: this is the user-selected theme (can't be storm, for example) that will be reverted back to after a storm
export function setSelectedTheme(theme) {
  return {
    type: SET_SELECTED_THEME,
    theme,
  };
}

export function setTimestampLastAskedForReview(timestamp) {
  return {
    type: SET_TIMESTAMP_LAST_ASKED_FOR_REVIEW,
    timestamp,
  };
}

export function setGoalAssignmentSelections(goalId, assignmentSelections) {
  return {
    type: SET_GOAL_ASSIGNMENT_SELECTIONS,
    goalId,
    assignmentSelections,
  };
}

export function setGoalAssignmentSelectionReviewPercentage(reviewPercentage) {
  return {
    type: SET_GOAL_ASSIGNMENT_SELECTION_REVIEW_PERCENTAGE,
    reviewPercentage,
  };
}

export function setStormIsThunderOn(isOn) {
  return {
    type: SET_STORM_IS_THUNDER_ON,
    isOn,
  };
}

export function setStormIsLightningOn(isOn) {
  return {
    type: SET_STORM_IS_LIGHTNING_ON,
    isOn,
  };
}

export function setStormIsRainOn(isOn) {
  return {
    type: SET_STORM_IS_RAIN_ON,
    isOn,
  };
}

export function addTimeToStorm(msToAdd) {
  return {
    type: ADD_STORM_TIME,
    msToAdd,
  };
}

export function addStormLesson() {
  return {
    type: ADD_STORM_LESSON,
  };
}

export function clearStormLessons() {
  return {
    type: CLEAR_STORM_LESSONS,
  };
}

export function fetchNotificationPreferences() {
  const endpoint = `${globals.apiUrl}/user/notification_preferences`;
  return createApiAction({
    endpoint,
    method: GET,
    types: getFetchTypes(endpoint, SET_NOTIFICATION_PREFERENCES),
  });
}

export function updateNotificationPreferences(updatedFields) {
  const formData = new FormData();
  Object.entries(updatedFields).forEach(([k, v]) => {
    formData.append(k, String(v));
  });
  const endpoint = `${globals.apiUrl}/user/notification_preferences`;
  return createApiAction({
    endpoint,
    method: PATCH,
    body: formData,
    types: getFetchTypes(endpoint, SET_NOTIFICATION_PREFERENCES),
  });
}

// @MARK: schools
export function fetchMyClassroomsTeacher() {
  const endpoint = `${globals.apiUrl}/classrooms`;
  return createApiAction({
    endpoint,
    method: GET,
    types: getFetchTypes(endpoint, SET_CLASSROOMS),
  });
}

export function assignGoalToStudent(classroomId, goalId, studentId) {
  const endpoint = `${globals.apiUrl}/classrooms/${classroomId}/goals/${goalId}/students/${studentId}`;
  return createApiAction({
    endpoint,
    method: POST,
    types: getFetchTypes(endpoint, SET_CLASSROOM_GOALS),
  });
}

/* @TODO: need this? or just fetchMyClassroom?
export function fetchClassroom(classroomId) {
  const endpoint = `${globals.apiUrl}/classrooms/${classroomId}`;
  return createApiAction({
    endpoint,
    method: GET,
    types: getFetchTypes(endpoint, ADD_CLASSROOMS),
  });
}
*/

export function fetchSchool(schoolId) {
  const endpoint = `${globals.apiUrl}/schools/${schoolId}`;
  return createApiAction({
    endpoint,
    method: GET,
    types: getFetchTypes(endpoint, SET_SCHOOL),
  });
}

export function fetchClassroomGoals(classroomId) {
  const endpoint = `${globals.apiUrl}/classrooms/${classroomId}/goals`;
  return createApiAction({
    endpoint,
    method: GET,
    types: getFetchTypes(endpoint, SET_CLASSROOM_GOALS),
  });
}

export function fetchClassroomStudents(classroomId) {
  const endpoint = `${globals.apiUrl}/classrooms/${classroomId}/students`;
  return createApiAction({
    endpoint,
    method: GET,
    types: getFetchTypes(endpoint, SET_CLASSROOM_STUDENTS),
  });
}

export function inviteStudents(classroomId, studentNames) { // @TODO: or by email
  const insertJson = {
    student_names: studentNames,
  };
  const endpoint = `${globals.apiUrl}/classrooms/${classroomId}/students`;
  return createApiAction({
    endpoint,
    method: POST,
    body: JSON.stringify(insertJson),
    headers: JSON_HEADERS,
    types: getFetchTypes(endpoint, SET_CLASSROOM_STUDENTS),
  });
}

export function updateClassroomStudent(classroomId, classroomStudentId, updateFields) {
  const endpoint = `${globals.apiUrl}/classrooms/${classroomId}/students/${classroomStudentId}`;
  const formData = new FormData();
  if (updateFields.status) {
    formData.append('status', updateFields.status);
  }
  return createApiAction({
    endpoint,
    method: PATCH,
    body: formData,
    types: getFetchTypes(endpoint, SET_CLASSROOM_STUDENTS),
  });
}

export function createModule(classroomId, goalId, moduleName, dateAvailable, dateDeadline) {
  const endpoint = `${globals.apiUrl}/classrooms/${classroomId}/goals/${goalId}/modules`;
  const insertJson = {} as any;
  insertJson.name = moduleName;
  if (dateAvailable !== undefined) { // null is a valid value
    insertJson.date_available = _jsDateToMysqlDate(dateAvailable);
  }
  if (dateDeadline !== undefined) { // null is a valid value
    insertJson.date_deadline = _jsDateToMysqlDate(dateDeadline);
  }
  // @TODO: assignment order
  return createApiAction({
    endpoint,
    method: POST,
    body: JSON.stringify(insertJson),
    headers: JSON_HEADERS,
    types: getFetchTypes(endpoint, SET_CLASSROOM_GOAL),
  });
}

export function updateModule(classroomId, goalId, moduleId, moduleName, dateAvailable, dateDeadline, status, assignmentIds) {
  const endpoint = `${globals.apiUrl}/classrooms/${classroomId}/goals/${goalId}/modules/${moduleId}`;
  const updateJson = {} as any;
  if (moduleName) {
    updateJson.name = moduleName;
  }
  if (dateAvailable !== undefined) { // null is a valid value
    updateJson.date_available = _jsDateToMysqlDate(dateAvailable);
  }
  if (dateDeadline !== undefined) { // null is a valid value
    updateJson.date_deadline = _jsDateToMysqlDate(dateDeadline);
  }
  if (status) {
    updateJson.status = status;
  }
  if (assignmentIds) {
    updateJson.assignment_order = assignmentIds;
  }
  // @TODO: deadline
  // @TODO: assignment order
  return createApiAction({
    endpoint,
    method: PATCH,
    body: JSON.stringify(updateJson),
    headers: JSON_HEADERS,
    types: getFetchTypes(endpoint, SET_CLASSROOM_GOAL),
  });
}

export function deleteModule(classroomId, goalId, moduleId) {
  const formData = new FormData();
  const endpoint = `${globals.apiUrl}/classrooms/${classroomId}/goals/${goalId}/modules/${moduleId}`;
  return createApiAction({
    endpoint,
    method: DELETE,
    body: formData,
    types: getFetchTypes(endpoint, SET_CLASSROOM_GOAL),
  });
}

export function createAssignment(classroomId, goalId, moduleId, assignmentName, dateAvailable, dateDeadline, status, type, assignmentSettings) {
  const endpoint = `${globals.apiUrl}/classrooms/${classroomId}/goals/${goalId}/assignments`;
  const insertJson = {} as any;
  insertJson.module_id = moduleId;
  insertJson.name = assignmentName;
  if (dateAvailable !== undefined) { // null is a valid value
    insertJson.date_available = _jsDateToMysqlDate(dateAvailable);
  }
  if (dateDeadline !== undefined) { // null is a valid value
    insertJson.date_deadline = _jsDateToMysqlDate(dateDeadline);
  }
  if (status) {
    insertJson.status = status;
  }
  if (type) {
    insertJson.type = type;
  }
  Object.keys(assignmentSettings).forEach((key) => {
    insertJson[key] = assignmentSettings[key];
  });
  // @TODO: other fields
  return createApiAction({
    endpoint,
    method: POST,
    body: JSON.stringify(insertJson),
    headers: JSON_HEADERS,
    types: getFetchTypes(endpoint, ADD_ASSIGNMENT_TO_CLASSROOM_GOAL),
  });
}

export function duplicateAssignment(classroomId, goalId, moduleId, assignmentId) {
  const endpoint = `${globals.apiUrl}/classrooms/${classroomId}/goals/${goalId}/modules/${moduleId}/assignments/${assignmentId}/duplicate`;
  return createApiAction({
    endpoint,
    method: POST,
    types: getFetchTypes(endpoint, ADD_ASSIGNMENT_TO_CLASSROOM_GOAL),
  });
}

export function updateAssignment(classroomId, goalId, assignmentId, assignmentName, dateAvailable, dateDeadline, status, type, assignmentSettings) {
  const endpoint = `${globals.apiUrl}/classrooms/${classroomId}/goals/${goalId}/assignments/${assignmentId}`;
  const updateJson = {} as any;
  if (assignmentName !== undefined) {
    updateJson.name = assignmentName;
  }
  if (dateAvailable !== undefined) { // null is a valid value
    updateJson.date_available = _jsDateToMysqlDate(dateAvailable);
  }
  if (dateDeadline !== undefined) { // null is a valid value
    updateJson.date_deadline = _jsDateToMysqlDate(dateDeadline);
  }
  if (status) {
    updateJson.status = status;
  }
  if (type) {
    updateJson.type = type;
  }
  Object.keys(assignmentSettings).forEach((key) => {
    updateJson[key] = assignmentSettings[key];
  });
  return createApiAction({
    endpoint,
    method: PATCH,
    body: JSON.stringify(updateJson),
    headers: JSON_HEADERS,
    types: getFetchTypes(endpoint, SET_CLASSROOM_GOAL),
  });
}

export function deleteAssignment(classroomId, goalId, moduleId, assignmentId) {
  const formData = new FormData();
  formData.append('module_id', moduleId);
  const endpoint = `${globals.apiUrl}/classrooms/${classroomId}/goals/${goalId}/assignments/${assignmentId}`;
  return createApiAction({
    endpoint,
    method: DELETE,
    body: formData,
    types: getFetchTypes(endpoint, SET_CLASSROOM_GOAL),
  });
}

// @MARK: admin
export function fetchAdminWhatsNew() {
  const endpoint = `${globals.apiUrl}/admin/whats_new`;
  return createApiAction({
    endpoint,
    method: GET,
    body: null,
    types: getFetchTypes(endpoint, SET_WHATS_NEW_NOTES),
  });
}

export function adminSaveNewWhatsNewNote(releaseNotes, releaseDate, appVersion, isIosSupported, isAndroidSupported, isWebSupported, link, isVisible) {
  const formData = new FormData();
  formData.append('release_notes', releaseNotes);
  formData.append('release_date', _jsDateToMysqlDate(releaseDate));
  formData.append('app_version', appVersion);
  formData.append('is_ios', String(+isIosSupported));
  formData.append('is_android', String(+isAndroidSupported));
  formData.append('is_web', String(+isWebSupported));
  formData.append('link', link);
  formData.append('is_visible', String(+isVisible));
  const endpoint = `${globals.apiUrl}/admin/whats_new`;
  return createApiAction({
    endpoint,
    method: POST,
    body: formData,
    types: getFetchTypes(endpoint, SET_WHATS_NEW_NOTES),
  });
}

export function apiUpdateWhatsNewNote(whatsNewId, updatedValues) {
  const updateJson = {} as any;
  const fields = Object.keys(updatedValues);
  if (fields.includes('appVersion')) {
    updateJson.app_version = updatedValues.appVersion;
  }
  if (fields.includes('releaseDate')) {
    updateJson.release_date = dateFnsFormat(updatedValues.releaseDate, 'yyyy-MM-dd');
  }
  if (fields.includes('isIos')) {
    updateJson.is_ios = +updatedValues.isIos;
  }
  if (fields.includes('isAndroid')) {
    updateJson.is_android = +updatedValues.isAndroid;
  }
  if (fields.includes('isWeb')) {
    updateJson.is_web = +updatedValues.isWeb;
  }
  if (fields.includes('releaseNotes')) {
    updateJson.release_notes = updatedValues.releaseNotes;
  }
  if (fields.includes('link')) {
    updateJson.link = updatedValues.link;
  }
  if (fields.includes('isSupported')) {
    updateJson.is_supported = updatedValues.isSupported;
  }
  if (fields.includes('isVisible')) {
    updateJson.is_visible = updatedValues.isVisible;
  }
  // @TODO: if no key/value pairs in json, don't make request
  const endpoint = `${globals.apiUrl}/admin/whats_new/${whatsNewId}`;
  return createApiAction({
    endpoint,
    method: PATCH,
    body: JSON.stringify(updateJson),
    headers: JSON_HEADERS,
    types: getFetchTypes(endpoint, SET_WHATS_NEW_NOTES),
  });
}

export function fetchTags() { // @TODO: admin only
  const endpoint = `${globals.apiUrl}/goals/tags`;
  return createApiAction({
    endpoint,
    method: GET,
    types: getFetchTypes(endpoint, SET_TAGS),
  });
}

export function fetchAllSchools() { // @TODO: should be in admin actions file
  const endpoint = `${globals.apiUrl}/admin/schools`;
  return createApiAction({
    endpoint,
    method: GET,
    types: getFetchTypes(endpoint, SET_SCHOOLS),
  });
}

export function adminAddSchool(schoolName, successCallback) { // @TODO: move to admin actions file // @TODO: combine with school admins
  const updateJson = {
    name: schoolName,
  };
  const endpoint = `${globals.apiUrl}/admin/schools`;
  return createApiAction({
    endpoint,
    method: POST,
    body: JSON.stringify(updateJson),
    headers: JSON_HEADERS,
    types: getFetchTypes(endpoint, SET_SCHOOLS),
  }, {callback: async (__dispatch, response) => {
    if (!response.error) {
      successCallback();
    }
  }});
}

export function adminDeleteBatch(batchId) { // @TODO: move to admin actions file
  const endpoint = `${globals.apiUrl}/admin/api_sync_staging_metadata/${batchId}`;
  return createApiAction({
    endpoint,
    method: DELETE,
    types: getFetchTypes(endpoint, SET_API_SYNC_STAGING_METADATA),
  });
}

export function adminEditTranslation(translationId, abbreviation, name, nameEnglish, localeId, url, version) { // @TODO: move to admin actions file
  const updateJson = {
    translation_id: translationId,
    abbreviation,
    name,
    name_english: nameEnglish,
    locale_id: localeId,
    url,
    version,
    batch_id: uuidv4(),
  };
  const endpoint = `${globals.apiUrl}/admin/translations_staging`;
  return createApiAction({
    endpoint,
    method: PATCH,
    body: JSON.stringify(updateJson),
    headers: JSON_HEADERS,
    types: getFetchTypes(endpoint, SET_API_SYNC_STAGING_METADATA),
  });
}

export function adminAddClassroom(schoolId, classroomName, isJoinCodeEnabled, teacherDisplayName, teacherUserId, successCallback) { // @TODO: move to admin actions file // @TODO: shouldn't just be admin anymore
  const updateJson = {
    name: classroomName,
    school_id: schoolId,
    is_join_code_enabled: isJoinCodeEnabled,
    teacher_display_name: teacherDisplayName,
    teacher_user_id: teacherUserId,
  };
  const endpoint = `${globals.apiUrl}/admin/classrooms`;
  return createApiAction({
    endpoint,
    method: POST,
    body: JSON.stringify(updateJson),
    headers: JSON_HEADERS,
    types: getFetchTypes(endpoint, SET_SCHOOLS),
  }, {callback: async (__dispatch, response) => {
    if (!response.error) {
      successCallback();
    }
  }});
}

export function adminUpdateClassroom(classromId, updatedValues, successCallback) { // @TODO: move to admin actions file // @TODO: shouldn't just be admin anymore
  const updateJson = {} as any;
  const fields = Object.keys(updatedValues);
  if (fields.includes('name')) {
    updateJson.name = updatedValues.name;
  }
  if (fields.includes('joinCode')) {
    updateJson.join_code = updatedValues.joinCode;
  }
  if (fields.includes('isJoinCodeEnabled')) {
    updateJson.is_join_code_enabled = updatedValues.isJoinCodeEnabled;
  }
  const endpoint = `${globals.apiUrl}/admin/classrooms/${classromId}`;
  return createApiAction({
    endpoint,
    method: PATCH,
    body: JSON.stringify(updateJson),
    headers: JSON_HEADERS,
    types: getFetchTypes(endpoint, SET_SCHOOLS),
  }, {callback: async (__dispatch, response) => {
    if (!response.error) {
      successCallback();
    }
  }});
}

export function masqueradeAs(userId, callback) { // @TODO: should be in admin actions file
  const endpoint = `${globals.apiUrl}/admin/users/${userId}/masquerade`;
  return createApiAction({
    endpoint,
    method: POST,
    types: getFetchTypes(endpoint, SET_MASQUERADE_AS),
  }, {callback: async () => {
    callback();
  }});
}

export function stopMasquerading() { // @TODO: should be in admin actions file
  return {
    type: CLEAR_MASQUERADE_AS,
  };
}

export function fetchAdminAnalytics() {
  const endpoint = `${globals.apiUrl}/admin/analytics`;
  return createApiAction({
    endpoint,
    method: GET,
    types: getFetchTypes(endpoint, SET_ADMIN_ANALYTICS),
  });
}

export function fetchApiSyncStagingMetadata() {
  const endpoint = `${globals.apiUrl}/admin/api_sync_staging_metadata`;
  return createApiAction({
    endpoint,
    method: GET,
    types: getFetchTypes(endpoint, SET_API_SYNC_STAGING_METADATA),
  });
}

export function decideOnApiSyncChanges(metadataIds, status: ('accepted' | 'rejected')) {
  const endpoint = `${globals.apiUrl}/admin/api_sync_staging_metadata`;
  return createApiAction({
    endpoint,
    method: PATCH,
    body: JSON.stringify({
      metadata_ids: metadataIds,
      status,
    }),
    headers: JSON_HEADERS,
    types: getFetchTypes(endpoint, SET_API_SYNC_STAGING_METADATA),
  }, {callback: async (dispatch, response) => {
    if (!response.error) {
      dispatch(fetchTranslations());
    }
  }});
}

export function createNewSchool(schoolName, classroomName, teacherDisplayName, callback) {
  const formData = new FormData();
  formData.append('school_name', schoolName);
  formData.append('classroom_name', classroomName);
  formData.append('teacher_display_name', teacherDisplayName);
  const endpoint = `${globals.apiUrl}/schools`;
  return createApiAction({
    endpoint,
    method: POST,
    body: formData,
    types: getFetchTypes(endpoint, SET_SCHOOL),
  }, {callback: async (__dispatch, response) => {
    if (!response.error) {
      callback?.(response.payload.school.id);
    } // @TODO: else show error
  }});
}

export function updateSchoolInfo(schoolId, updatedValues, successCallback) {
  const endpoint = `${globals.apiUrl}/schools/${schoolId}`;
  return createApiAction({
    endpoint,
    method: PATCH,
    body: JSON.stringify(updatedValues),
    headers: JSON_HEADERS,
    types: getFetchTypes(endpoint, SET_SCHOOL),
  }, {loadingStateToTrack: 'updateSchoolInfo', callback: async (__dispatch, response) => {
    if (!response.error) {
      successCallback();
    }
  }});
}

export function addSeats(schoolId, numberOfSeats, successCallback) { // @TODO: move to schools actions file
  const formData = new FormData();
  formData.append('number_of_seats', numberOfSeats);
  const endpoint = `${globals.apiUrl}/schools/${schoolId}/seats`;
  return createApiAction({
    endpoint,
    method: POST,
    body: formData,
    types: getFetchTypes(endpoint, SET_SCHOOL), // @TODO: right action type?
  }, {callback: async (__dispatch, response) => {
    if (!response.error) {
      successCallback();
    } // @TODO: else show error
  }});
}

export function uploadSchoolLogo(base64Image, schoolId, successCallback) {
  const formData = new FormData();
  formData.append('file', base64Image);
  const endpoint = `${globals.apiUrl}/schools/${schoolId}/logo`;
  return createApiAction({
    endpoint,
    method: PUT,
    body: formData,
    types: getFetchTypes(endpoint, ''), // @TODO: need a success action type? probably not...
  }, {callback: async () => successCallback()});
}

export function syncBible(translationApiId, availableInVersion, batchId, successCallback, errorCallback, checkSyncStatusOnly, endpoint = undefined, autoAcceptNew = false, forceRefresh = false) {
  const useLegacyApi = ['78a9f6124f344018-01', '01c25b8715dbb632-01', 'da0947e25c9636bb-01'].includes(translationApiId); // @TODO: yeet when these are switched over (NIV, ESV, NVI, HFA)
  const queryParams = new URLSearchParams();
  queryParams.append('batch_id', batchId);
  queryParams.append('available_in_version', availableInVersion);
  queryParams.append('check_sync_status_only', `${+checkSyncStatusOnly}`);
  queryParams.append('auto_accept_new', `${+autoAcceptNew}`);
  queryParams.append('use_legacy_api', `${+useLegacyApi}`);
  queryParams.append('force_refresh', `${+forceRefresh}`);
  // @TODO: queryParams.append('book_id', '35'); // @TODO: yeet
  // @TODO: queryParams.append('chapter_number', '1'); // @TODO: yeet
  endpoint = endpoint || `${globals.apiUrl}/admin/api_sync/${translationApiId}?${queryParams.toString()}`;
  return createApiAction({
    endpoint,
    method: POST,
    types: getFetchTypes(endpoint, ''),
  }, {callback: async (dispatch, response) => {
    if (response?.payload.next_url) { // @NOTE: `response` will be `undefined` if `bailout` above is executed, so do a null-check here
      dispatch(syncBible(response.payload.next_translation_api_id, availableInVersion, batchId, successCallback, errorCallback, checkSyncStatusOnly, response.payload.next_url, autoAcceptNew));
    }
    const isSyncComplete = !response?.payload.next_url;
    if (!response.error) {
      successCallback(
        response?.payload.is_error,
        isSyncComplete ? null : response.payload.next_book_id,
        response?.payload.message,
        response?.payload.next_url,
      );
    } else {
      if (response.meta.responseStatus === 504) {
        errorCallback(globals.timeoutMessage);
      } else {
        errorCallback('Sync failed');
      }
    }
  }});
}

export function setDontAskForPNPerms(value) {
  return {
    type: SET_DONT_ASK_FOR_PN_PERMS,
    value,
  };
}

export function setGoalHideCompleted(goalId) {
  return {
    type: GOAL_HIDE_COMPLETED,
    goalId,
  };
}

export function setGoalShowCompleted(goalId) {
  return {
    type: GOAL_SHOW_COMPLETED,
    goalId,
  };
}

export {
  apiDeleteAccount,
  cleanProfilePictureUrls,
  fetchChatMessages,
  fetchProfilePictureUrl,
  fetchWhatsNew,
  getRequestHeaders,
  logout,
  markAllMessagesRead,
  saveFcmToken,
  sendChatMessage,
  sendContactFormMessage,
  setFeedbackChatDraftText,
  setLightDarkMode,
  setMessageReaction,
  setWhatsNewLastReadTimestamp,
  setWhatsNewLastReadVersion,
};
